import { Box, useMediaQuery, useTheme } from "@mui/material";
import { t } from "i18next";
import { Dispatch, SetStateAction } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TabsContentProps } from "./TabsContent.types";
import {
  ButtonLink
  //Carousel
  // CarouselCard
} from "../../components";
import { Carousel } from "../../components/Carousel_v2/Carousel.component";
import { CarouselStyle } from "../../components/Carousel_v2/Carousel.styles";
import { CarouselCardRestyle } from "../../components/CarouselCardRestyle/CarouselCardRestyle.component";
import {
  //CAROUSEL_TYPE,
  STATUS_LO
} from "../../consts";

import { useLanguageStore } from "../../stores";
import { createEndDate, createStartDate } from "../../utils/general";
import { useRouteParamsLo } from "../../utils/useRouteParamsLo";

export function TabsContentActivities({
  contentActivities,
  courseId,
  currentLO,
  rootId,
  setOpenModalEcm,
  title
} :
  & Pick<
    TabsContentProps,
    | "currentLO"
    | "courseId"
    | "rootId"
    >
  & Required<
    Pick<
    TabsContentProps,
    | "contentActivities"
    | "title"
    | "currentLO"
  > & {
    setOpenModalEcm:Dispatch<SetStateAction<boolean>> | undefined
  }
>
) {
  const { state: routerState } = useLocation();

  const {
    courseIdNumber,
    rootIdNumber
  } = useRouteParamsLo();

  const navigate = useNavigate();
  const minActivities = 4;
  const showCta = (contentActivities.length > minActivities);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const language = useLanguageStore(state => state.language)?.id;

  return (
    <>
      {
        showCta &&
          <Box
            sx={ {
              display:"flex",
              justifyContent: "flex-end",
              width: "100%"
            } }
          >
            <ButtonLink
              sx={ {
                cursor: "pointer",
                fontSize: "1.125rem",
                fontWeight: "500",
                minWidth: "unset",
                padding: "0 0 1rem",
                textDecoration: "underline",
                whiteSpace: "nowrap",
                zIndex: "1000",

                "&:hover": {
                  background:"none",
                  boxShadow:"none"
                },
                [theme.breakpoints.down("sm")]: {
                  fontSize:"0.75rem"
                },

                "&.Mui-disabled": {
                  color:theme.customColors.backgroundDisabled,
                  textDecoration:"none"
                }
              } }
              onClick={ ()=>{navigate("/activitiesDetail",
                { state:{
                  ...routerState,
                  areCardsEnabled:Boolean(currentLO?.ecm_specialization && !currentLO.ecmRegistration),
                  contentActivities: contentActivities,
                  courseId: courseIdNumber,
                  learningObjectType: currentLO.learningObjectType,
                  learningObjectTypology: currentLO.learningObjectTypology,
                  rootId: rootIdNumber,
                  title: title
                }
                });
              } }
            >
              { t("view_all") }
            </ButtonLink>
          </Box>
      }
      <CarouselStyle aria-label={ title } className="carouselContainer" sx={ { paddingBottom: "1rem" } }>
        <Carousel
          centeredSlides={ isMobile ?true :false }
          carouselData={ contentActivities }
          slidesPerView={  isMobile ? 1 : "auto" }
          spaceBetween={ isMobile ? 1 : 11.2 }
          loopSlides={ true }
          hasPagination={ false }
          hideSweeperBulletsRight={ true }
          hasPaginationSweeperBullets={ false }
          title={ title + "-carousel-explore" }
          pauseOnMouseEnter={ true }
          renderElement={ (element,index ) => {
            return (
              <CarouselCardRestyle
                key={ `tab-content-activities-${index}--${language}` }
                booked={ element.status !== STATUS_LO.N && element.status !== STATUS_LO.T }
                categories={ element.topicTags || [] }
                coverPublicURL={ element?.coverPublicURL }
                //coverVideoPublicURL={ element.videoPublicURL } diverso
                coverVideoPublicURL={ element?.coverVideoPublicURL }
                disabled={
                  element.isEnable === false ||
                  Boolean(currentLO?.ecm_specialization && !currentLO.ecmRegistration)
                }
                duration={ element.duration }
                //editionNumber={ element?.editionNumber } // non è presente nella logica Activities tab card
                //ecmRegistration={ element.ecmRegistration } diverso
                ecmRegistration={ currentLO.ecmRegistration }
                //ecm_specialization={ element.ecm_specialization } diverso
                ecm_specialization={ currentLO.ecm_specialization }
                endDate={ createEndDate(element)  }
                enrollType={ element.enrollType }
                expirationDate={ element.expirationDate }
                grandParentId={ element?.grandParentId ?? undefined } // non è presente nella logica Activities tab card
                id={ element.id }
                //isAutoSubscribeEnable={ true } diverso
                isAutoSubscribeEnable={ element.isAutoSubscribeEnable }
                isFavourite={ element.isFavourite }
                isStandAlone={ element.isStandAlone }
                //isToj={ element.isToj } diverso
                isToj={ false }
                isEditorial={ element.isEditorial }
                learningObjectType={ element.learningObjectType }
                learningObjectTypology={ element.learningObjectTypology }
                parentId={ element?.parentId ?? undefined }  // non è presente nella logica Activities tab card
                percentageOfCompletion={ element.percentageOfCompletion }
                shortDescription={ element.shortDescription }
                startDate={ createStartDate(element)  }
                status={ element.status || "N" }
                title={ element.title }
                //canAccessNow={ element.canAccessNow } diverso
                canAccessNow={ currentLO.canAccessNow }
                //isLinkRelative={ element.isLinkRelative }diverso
                isLinkRelative={ !!currentLO.isLinkRelative }
                //link={ element.link } diverso
                link={ currentLO.link }
                //variabili non utilizzate in precedenza nalla page esplora
                courseId={ element.courseId ?? courseId }
                isSurvey={ element.isSurvey }
                isTest={ element.isTest }
                rootId={ rootId }
                setOpenModalEcm={ setOpenModalEcm }
                small={ true }
                attributes={ element?.attributes }
                isMandatory={ element.isMandatory }
                externalFileUrl={ element?.externalFileUrl }
              />
            );
          } }/>
      </CarouselStyle>
    </>

  );
}
/* CARD VECCHIA CON SOLO LE PROPS CHE NON vengono  UTILAZZATE rispetto alla page explora
                <CarouselCard
                ** courseId={ card.courseId ?? courseId }
                **isSurvey={ card.isSurvey }
                **isTest={ card.isTest }
                **ootId={ rootId }
                **setOpenModalEcm={ setOpenModalEcm }
                **small={ true }
              />
                 */
